import {useEffect, useCallback} from 'react';

function useCalculatePercent(
  range: React.RefObject<HTMLDivElement>,
  maxValRef: React.RefObject<HTMLInputElement>,
  max: number,
  min: number,
  minVal: number,
): void {
  const getPercent = useCallback(
    (value: number) => Math.round(((value - min) / (max - min)) * 100),
    [min, max],
  );
  useEffect(() => {
    if (maxValRef.current) {
      const minPercent = getPercent(minVal);
      const maxPercent = getPercent(+maxValRef.current.value); // Precede with '+' to convert the value from type string to type number

      if (range.current) {
        range.current.style.left = `${minPercent}%`;
        range.current.style.width = `${maxPercent - minPercent}%`;
      }
    }
  }, [getPercent, maxValRef, range, minVal]);
}
export default useCalculatePercent;
